// Require

const { id, log, jqm } = require("../std/index")
const { getInstanceFrom } = require("../widgets/index")


// Helpers

const rxDiameter = /\s\d\d(-\d\d|\+)/;


//
// Cart Controller
//
// Handles attempts to remove items by itercepting button clicks and submitting
// the form
//

module.exports = class CartController {
  constructor($page, $$) {
    const $removeButtons = $$('[data-widget="invisible-checkbox"]');
    const $cartUpdateButton = $$('[data-update-cart]');

    for (const removeWidget of $removeButtons.toArray().map(getInstanceFrom)) {
      removeWidget.onChecked(() => $cartUpdateButton.click());
    }
  }
};
